import e from "../managers/braze-instance.js";
export function isInitialized() {
  return e.so();
}
